import { Link } from "react-router-dom";
import { categories, themeOptions, tagOptions } from "@/mocks/games";

interface FilterSidebarProps {
  categoryKey: string;
  theme: string;
  tags: string[];
  onThemeChange: (theme: string) => void;
  onTagsChange: (tags: string[]) => void;
  onReset: () => void;
}

export default function FilterSidebar({
  categoryKey,
  theme,
  tags,
  onThemeChange,
  onTagsChange,
  onReset,
}: FilterSidebarProps) {
  const toggleTag = (tag: string) => {
    if (tags.includes(tag)) {
      onTagsChange(tags.filter((item) => item !== tag));
    } else {
      onTagsChange([...tags, tag]);
    }
  };

  const hasFilter = Boolean(theme) || tags.length > 0;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
          <i className="ri-equalizer-line text-primary-500"></i>
          筛选条件
        </h2>
        {hasFilter && (
          <button
            type="button"
            onClick={onReset}
            className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600 transition hover:text-primary-700"
          >
            <i className="ri-refresh-line"></i>
            重置
          </button>
        )}
      </div>

      <div>
        <p className="mb-3 text-xs font-bold uppercase tracking-wide text-foreground-400">游戏类型</p>
        <div className="flex flex-wrap gap-2">
          {categories.map((category) => (
            <Link
              key={category.key}
              to={`/category/${category.key}`}
              className={`rounded-md px-2.5 py-1.5 text-xs font-medium transition ${
                category.key === categoryKey
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {category.name}
            </Link>
          ))}
        </div>
      </div>

      <div className="border-t border-background-200 pt-5">
        <p className="mb-3 text-xs font-bold uppercase tracking-wide text-foreground-400">游戏题材</p>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => onThemeChange("")}
            className={`rounded-md px-2.5 py-1.5 text-xs font-medium transition ${
              theme === ""
                ? "bg-accent-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-accent-100 hover:text-accent-700"
            }`}
          >
            全部题材
          </button>
          {themeOptions.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => onThemeChange(item === theme ? "" : item)}
              className={`rounded-md px-2.5 py-1.5 text-xs font-medium transition ${
                theme === item
                  ? "bg-accent-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-accent-100 hover:text-accent-700"
              }`}
            >
              {item}
            </button>
          ))}
        </div>
      </div>

      <div className="border-t border-background-200 pt-5">
        <p className="mb-3 text-xs font-bold uppercase tracking-wide text-foreground-400">
          热门标签
          {tags.length > 0 && <span className="ml-1 text-primary-600">（已选 {tags.length}）</span>}
        </p>
        <div className="flex flex-wrap gap-2">
          {tagOptions.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => toggleTag(tag)}
              className={`rounded-full px-3 py-1.5 text-xs font-medium transition ${
                tags.includes(tag)
                  ? "bg-secondary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-700"
              }`}
            >
              {tag}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}